import React, { useState } from "react";
import { webAPIRequest } from "../utils/AppMobx";
import { logDebug, logError } from "../LocalLogger";
import { collection, CollectionReference } from "firebase/firestore";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { v4 as uuidv4 } from "uuid";
// TODO :: shared
export interface DayByDay {
	title: string;
	description: string;
	distanceAndElevation: string;
}
export interface RectoVersoData {
	url: string;
	key?: string;
	publishedAt?: string;
	slugs?: { [lang: string]: string };
	distance: string;
	alevationGained: string;
	alevationLoss: string;
	months: string[];
	hikeIcons: string[];
	duration: string;

	level: string;
	dayByDay: DayByDay[];
	title: string;
	description: string;
	gettingThere: string;
	whereToSleep: string;
	goodToKnow: string;
	[key: string]: any;
}

const needTranslationKeys = ["slug", "level", "title", "description", "gettingThere", "whereToSleep", "goodToKnow", "dayByDay"]; //,
export const PortalPage: React.FC = () => {
	const [translate, setTranslate] = React.useState<Partial<RectoVersoData> | undefined>(undefined);
	const [original, setOriginal] = React.useState<Partial<RectoVersoData> | undefined>(undefined);
	const [haveChanges, setHaveChanges] = React.useState(false);
	const [selectedValue, setSelectedValue] = useState(""); // Or an empty array for multiple selection

	const [url, setUrl] = React.useState<string>("https://www.rectoverso.co/fiches/rando-france/randonnee-auvergne-volcan-bourboule-aydat");
	const firestore = useFirestore();
	const conceptsRef = collection(firestore, "/store/crawl/recto-verso") as CollectionReference<RectoVersoData>;
	const conceptsCD = useFirestoreCollectionData<RectoVersoData>(conceptsRef, { idField: "id" });

	if (!conceptsCD.data || conceptsCD.status !== "success") {
		return <div>Loading...</div>;
	}

	const handleDayBayChange = (e: React.FocusEvent<HTMLDivElement>, index: number, key: keyof DayByDay) => {
		const newContent = e.currentTarget.innerText;
		setTranslate((prevTranslate: any) => {
			const updatedDayByDay = (prevTranslate.dayByDay || []).map((day: DayByDay, i: number) => {
				if (i === index) {
					return { ...day, [key]: newContent.trim() };
				}
				return day;
			});
			const updated = { ...prevTranslate, dayByDay: updatedDayByDay };
			setHaveChanges(true);
			logDebug("Updated Day By Day:", updated);
			return updated;
		});
	};
	const handleContentChange = (e: React.FocusEvent<HTMLDivElement>, key: string) => {
		const newContent = e.currentTarget.innerText;
		setTranslate((prevTranslate: any) => {
			const updated = { ...prevTranslate, [key]: newContent.trim() };
			setHaveChanges(true);
			logDebug("Updated Translation:", updated);
			return updated;
		});
	};
	const collectionToWorkWith = conceptsCD.data.filter((e) => !e.id.includes("_translate") || e.id.includes("M~$~"));
	logDebug("Collection to work with:", collectionToWorkWith, conceptsCD.data);
	return (
		<div className="portal-page ">
			<div className="flex items-center">
				<select
					className="border rounded p-2 mb-4 w-[80%] m-4"
					value={selectedValue}
					onChange={(e) => {
						const selectedId = e.target.value;
						setSelectedValue(selectedId);
					}}
				>
					<option value="">Select a page to load or press new site</option>
					{/* Optional placeholder */}
					{collectionToWorkWith.map((site) => (
						<option key={site.id} value={site.id}>
							{site.slugs?.en || site.slugs?.he || site.title || "No Title"} ~ ~ ~ {site.url} ~~ {site.id}
						</option>
					))}
				</select>
				<button
					className="bg-green-500 text-white rounded p-2 m-4"
					onClick={async () => {
						setUrl("");
						setTranslate(undefined);
						setOriginal(undefined);
						setHaveChanges(false);
						if (selectedValue) {
							const url = conceptsCD.data.find((e) => e.id === selectedValue)?.url;
							const key = conceptsCD.data.find((e) => e.id === selectedValue)?.key;
							if (!url) {
								return;
							}
							document.body.style.cursor = "wait";
							try {
								const ret = await webAPIRequest("fetchRectoVersoSite", {
									url,
									key,
								});
								setTranslate(ret?.translation || {});
								setOriginal(ret?.site || {});
								logDebug("Recto Verso Site Result:", ret);
							} catch (err) {
								logDebug("Error fetching Recto Verso site:", err);
							}
							document.body.style.cursor = "";
						} else {
							// new site
							const key = `M~$~${uuidv4()}`;
							setTranslate({
								url: "manually entered page",
								key,
							});
							setOriginal({
								url: "manually entered page",
								key,
							});
						}
					}}
				>
					{selectedValue ? "Load Site" : "New Site"}
				</button>
			</div>
			<div className="flex items-center">
				<input
					value={url}
					onChange={(e) => setUrl(e.target.value)}
					type="text"
					className="border rounded p-2 mb-4 w-[50%] m-4"
					placeholder="Enter Recto Verso url..."
				/>
				<button
					disabled={!url}
					className="bg-blue-500 text-white rounded p-2 m-4 disabled:bg-gray-300"
					onClick={async () => {
						if (!url) {
							return;
						}
						setHaveChanges(false);
						setTranslate(undefined);
						setOriginal(undefined);
						document.body.style.cursor = "wait";
						try {
							const ret = await webAPIRequest("fetchRectoVersoSite", {
								url,
							});
							setTranslate(ret?.translation || {});
							setOriginal(ret?.site || {});
							logDebug("Recto Verso Site Test Result:", ret);
						} catch (err) {}
						document.body.style.cursor = "";
					}}
				>
					Fetch Site
				</button>
				<button
					disabled={!haveChanges || (!url && !translate?.url)}
					className="bg-red-500 text-white rounded p-2 m-4 disabled:bg-gray-300"
					onClick={async () => {
						if (!haveChanges || (!url && !translate?.url)) {
							return;
						}
						// change cursor to wait
						document.body.style.cursor = "wait";
						try {
							const ret = await webAPIRequest("updateTranslations", {
								key: translate?.key,
								url: translate?.url,
								data: translate,
							});
						} catch (err) {
							logError("Error updating translation:", err);
						}
						document.body.style.cursor = "";
						setHaveChanges(false);
					}}
				>
					Update Translation
				</button>
				<button
					disabled={!translate}
					className="bg-red-500 text-white rounded p-2 m-4 disabled:bg-gray-300"
					onClick={async () => {
						// change cursor to wait
						document.body.style.cursor = "wait";
						translate!.publishedAt = new Date().toISOString();
						try {
							const ret = await webAPIRequest("updateTranslations", {
								url,
								data: translate,
							});
						} catch (err) {}
						document.body.style.cursor = "";
						setHaveChanges(false);
					}}
				>
					Publish
				</button>
			</div>
			{
				needTranslationKeys.map((key) => {
					if (key === "dayByDay") {
						const dayByDayOrg = (original?.[key] || []) as DayByDay[];
						const dayByDayTranslate = (translate?.[key] || []) as DayByDay[];
						return dayByDayOrg.map((dayOrg, index) => {
							const dayTranslate = dayByDayTranslate[index] || {};
							return (
								<div key={key} className="p-4 w-full">
									<h2 className="text-lg font-bold">Day {index + 1}</h2>
									<div className="flex  w-full justify-between p-2 ">
										<div className="border rounded bg-gray-100 p-2 w-[48%]">{dayOrg.title || "N/A"}</div>
										<div
											onBlur={(e) => handleDayBayChange(e, index, "title")}
											// Suppress React warning
											contentEditable="true"
											className="border rounded bg-gray-200 p-2 mt-2 w-[48%]"
											style={{ direction: "rtl", textAlign: "right" }}
										>
											{dayTranslate.title || "N/A"}
										</div>
									</div>
									<div className="flex  w-full justify-between p-2 ">
										<div className="border rounded bg-gray-100 p-2 w-[48%]">{dayOrg.description || "N/A"}</div>
										<div
											onBlur={(e) => handleDayBayChange(e, index, "description")}
											// Suppress React warning
											contentEditable="true"
											className="border rounded bg-gray-200 p-2 mt-2 w-[48%]"
											style={{ direction: "rtl", textAlign: "right" }}
										>
											{dayTranslate.description || "N/A"}
										</div>
									</div>
								</div>
							);
						});
					} else if (key === "slug") {
						return (
							<div key={key} className="p-4 w-full">
								<h2 className="text-lg font-bold">{key}</h2>
								<div className="flex  w-full justify-between p-2 ">
									{/* <div className="border rounded bg-gray-100 p-2 w-[48%]">{original?.[key] || "N/A"}</div> */}
									<div
										onBlur={(e) => {
											const newContent = e.currentTarget.innerText;
											setTranslate((prevTranslate) => {
												if (!prevTranslate) {
													return undefined;
												}
												prevTranslate.slugs = prevTranslate.slugs || {};
												prevTranslate.slugs.en = newContent.trim();
												setHaveChanges(true);
												return { ...prevTranslate };
											});
										}}
										suppressContentEditableWarning={true} // Suppress React warning
										contentEditable="true"
										className="border rounded bg-gray-200 p-2 mt-2 w-[48%]"
									>
										{translate?.slugs?.en || "Slug in English"}
									</div>
									<div
										onBlur={(e) => {
											const newContent = e.currentTarget.innerText;
											setTranslate((prevTranslate) => {
												if (!prevTranslate) {
													return undefined;
												}
												prevTranslate.slugs = prevTranslate.slugs || {};
												prevTranslate.slugs.he = newContent.trim();
												setHaveChanges(true);
												return { ...prevTranslate };
											});
										}}
										suppressContentEditableWarning={true} // Suppress React warning
										contentEditable="true"
										className="border rounded bg-gray-200 p-2 mt-2 w-[48%]"
										style={{ direction: "rtl", textAlign: "right" }}
									>
										{translate?.slugs?.he || "סלג בעברית"}
									</div>
								</div>
							</div>
						);
					} else {
						return (
							<div key={key} className="p-4 w-full">
								<h2 className="text-lg font-bold">{key}</h2>
								<div className="flex  w-full justify-between p-2 ">
									<div className="border rounded bg-gray-100 p-2 w-[48%]">{original?.[key] || "N/A"}</div>
									<div
										onBlur={(e) => handleContentChange(e, key)}
										suppressContentEditableWarning={true} // Suppress React warning
										contentEditable="true"
										className="border rounded bg-gray-200 p-2 mt-2 w-[48%]"
										style={{ direction: "rtl", textAlign: "right" }}
									>
										{translate?.[key] || "N/A"}
									</div>
								</div>
							</div>
						);
					}
				})
				// <div className=" border rounded bg-gray-100 w-full">{original}</div>
				// <div className=" border rounded bg-gray-100 w-full" style={{ direction: "rtl", textAlign: "right" }}>
				// 	{translate}
				// </div>
			}{" "}
		</div>
	);
};
